import {
  startTransition,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import LoadingScreen from "../Components/LoadingScreen";
import SurveyTypeModel from "../Models/Survey/SurveyTypeModel";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SurveyService from "../Services/SurveyService";
import { toast } from "react-toastify";

interface Props {
  surveyTypeId: string;
  accountId: string;
  contactId?: string;
  contactSsin?: string;
}

export function SurveyType(props: Props) {
  const { t, i18n } = useTranslation("home");

  const navigate = useNavigate();

  const surveyService = useMemo(() => new SurveyService(), []);

  const [loading, setLoading] = useState<boolean>(false);
  const [surveyType, setSurveyType] = useState<SurveyTypeModel>();

  const surveyId = localStorage.getItem("surveyid");

  const loadSurveyType = useCallback(async () => {
    try {
      setLoading(true);
      if (props.surveyTypeId === "") {
        setSurveyType(undefined);
      }

      const data = await surveyService.getSurveyType(
        props.surveyTypeId,
        null,
        surveyId,
        props.accountId,
        props.contactId,
        props.contactSsin,
        i18n.language,
      );

      setSurveyType(data);
    } catch (error: any) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  }, [
    props.surveyTypeId,
    props.accountId,
    props.contactId,
    props.contactSsin,
    surveyService,
  ]);

  useEffect(() => {
    async function loadData() {
      await loadSurveyType();
    }

    loadData();
  }, [loadSurveyType]);

  if (surveyType && surveyType.isSurveyClosed) {
    return <h5>{t("Deze vragenlijst is afgesloten")}</h5>;
  }

  if (loading) {
    return <LoadingScreen />;
  }

  if (
    surveyType &&
    (surveyType.completed === true || surveyType.surveyId === null)
  ) {
    return (
      <>
        <h2 className="float-center">{surveyType.name}</h2>
        {surveyType?.allowNew === false ? (
          <>{t("Je hebt deze vragenlijst reeds ingevuld.")}</>
        ) : (
          <Button
            variant="contained"
            onClick={() => {
              localStorage.removeItem("surveyid");
              startTransition(() => {
                navigate("/survey", {
                  state: {
                    surveyType: {
                      surveyTypeId: surveyType.surveyTypeId,
                      name: surveyType.name,
                    },
                    accountId: props.accountId,
                    contactId: props.contactId,
                    contactSsin: props.contactSsin,
                  },
                });
              });
            }}
          >
            {t("Starten")}
          </Button>
        )}
      </>
    );
  }

  if (
    surveyType &&
    surveyType.completed === false &&
    surveyType.surveyId != null
  ) {
    return (
      <>
        <h2 className="float-center">{surveyType.name}</h2>
        <Grid item xs={12}>
          <Button
            className="m-3"
            variant="contained"
            onClick={() => {
              startTransition(() => {
                navigate("/survey", {
                  state: {
                    surveyType: {
                      surveyTypeId: surveyType.surveyTypeId,
                      name: surveyType.name,
                      surveyId: surveyType.surveyId,
                    },
                    accountId: props.accountId,
                    //contactId: props.contactId,
                  },
                });
              });
            }}
          >
            {t("Verdergaan")}
          </Button>

          {surveyType?.allowNew === false ? (
            <></>
          ) : (
            <Button
              className="m-3"
              variant="contained"
              onClick={() => {
                localStorage.removeItem("surveyid");
                startTransition(() => {
                  navigate("/survey", {
                    state: {
                      surveyType: {
                        surveyTypeId: surveyType.surveyTypeId,
                        name: surveyType.name,
                      },
                      accountId: props.accountId,
                      contactId: props.contactId,
                      contactSsin: props.contactSsin,
                    },
                  });
                });
              }}
            >
              {t("Starten")}
            </Button>
          )}
        </Grid>
      </>
    );
  }

  return <LoadingScreen />;
}
